import { Button } from "@sellar-io/components";
import { Icon } from "../../../components";
import { Alert } from "../../../components/alert/Alert";
import { AlertCompact } from "../../../components/alert/AlertCompact";
import { useSupplierRelationshipCount } from "../../../hooks/api/v2/supplierRelationship/useSupplierRelationshipCount";
import {
  CustomerPaymentFilterType,
  CustomerPaymentFilterValues,
} from "../customerList/CustomerListFilterTypes";

export const CustomerRequestBanner = ({
  setFilterValue,
  compact,
}: {
  setFilterValue: (value: CustomerPaymentFilterType) => void;
  compact?: boolean;
}) => {
  const connectionCountQuery = useSupplierRelationshipCount({
    query: [CustomerPaymentFilterValues.pending.mutation("")].flatMap((x) =>
      x ? x : [],
    ),
  });

  const customerCount = connectionCountQuery.data ?? 0;

  if (customerCount === 0) return null;

  if (compact)
    return (
      <AlertCompact
        type="information"
        onClick={() => setFilterValue(CustomerPaymentFilterValues.pending.key)}
        className="w-full md:w-auto"
      >
        <span className="font-bold">
          {customerCount} new connection requests{" "}
          <span className="font-normal">pending</span>
        </span>
        <span className="ml-auto flex items-center font-bold text-indigo-800 md:ml-2">
          View <Icon icon="CHEVRON_RIGHT" />
        </span>
      </AlertCompact>
    );

  return (
    <Alert
      className={"w-full"}
      type={"information"}
      title={`You have ${customerCount} new customer connection requests pending.`}
      message={"Assign their price tier and credit terms"}
    >
      <Button
        onClick={() => setFilterValue(CustomerPaymentFilterValues.pending.key)}
        color={"secondary"}
        className={"border-blue-300 bg-blue-100 text-blue-800"}
      >
        View {customerCount > 1 ? "customers" : "customer"}
      </Button>
    </Alert>
  );
};
